export function tableConfig (getMoney) {
  return {
      menuType: "button",
      addBtn: false,
      menuWidth: 120,
      menuAlign: "center",
      card: true,
      menu: false,
      delBtn: false,
      editBtn: false,
      align: "center",
      searchMenuSpan: 8,
      columnBtn: false,
      searchBtn: true,
      index: true,
      indexLabel: "序号",
      indexWidth: 35,
      refreshBtn: true,
      selection: true,
      selectionWidth: 30,
      searchShow: false,
      showSummary: true,
      column: [
        {
          label: "搜索查询",
          searchPlaceholder: "基金编号/基金名称",
          placeholder: "基金编号/基金名称",
          prop: "search1",
          hide: true,
          display: true,
          search: true,
          hideshow: true,
        },
        // {
        //   sortable: "custom",
        //   label: "基金编号",
        //   prop: "number",
        //   width: "120",
        //   fixed: true
        // },
        {
          label: "出资主体",
          prop: "name",
          // width: "120",
          slot: true,
          // fixed: true
        },
        {
          label: "投资/退出明细",
          bind: "fundDetail",
          prop: "fundDetail",
          width: 100,
          slot: true,
        },
        // {
        //   label: "审核状态",
        //   prop: "auditState",
        //   type: "select",
        //   search: true,
        //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
        //   props: {
        //     label: "dictValue",
        //     value: "dictKey"
        //   }
        // },
        {
          label: "设立时间",
          width: "80",
          prop: "establishmentTime",
        },
        {
          label: "注册资本",
          prop: "peScale",
          width: "85",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }

        },
        {
          label: "基金实缴金额(万元)",
          prop: "totalCapitalPaid",
          width: "130",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },
        // {
        //   label: "政府产业基金认缴规模",
        //   prop: "govIndustrySubscribed",
        //   width: "160",
        //   formatter: (row, value, label, column) => {
        //     if (value == -1) {
        //       return "-";
        //     } else {
        //       return getMoney(value)+' 元';
        //     }
        //   }
        // },
        {
          label: "直投规模(万元)",
          prop: "directInvestScale",
          width: "100",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },
        {
          label: "合作基金认缴(万元)",
          prop: "cooperationFundSubscribed",
          width: "130",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },
        {
          label: "实缴规模(万元)",
          prop: "cooperationFundPaid",
          width: "100",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },
        {
          label: "合作基金已投金额(万元)",
          prop: "cooperationFundInvested",
          width: "150",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },            
        //  {
        //   label: "出资比例",
        //   prop: "capitalRatio",
        //   width: "160",
        //   formatter: (row, value, label, column) => {
        //     if (value == -1) {
        //       return "-";
        //     } else {
        //       return getMoney(value) +' %';
        //       }
        //   }
        // },
        // {
        //   label: "基金管理人",
        //   prop: "managerName",
        //   width: "150",
        //   search: false,
        // },
        {
          label: "经办人",
          prop: "managerUserName",
          width:70
        }
      ]
    }
}

export function examConfig(getMoney){
  return{
    menuType: "button",
    addBtn: false,
    menuWidth: 95,
    menuAlign: "center",
    card: true,
    refreshBtn:false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    column: [
      {
        label: "搜索查询",
        searchPlaceholder: "基金编号/基金名称",
        placeholder: "基金编号/基金名称",
        prop: "search1",
        hide: true,
        display: true,
        search: true,
        hideshow: true,
      },
      {
        sortable: "custom",
        label: "基金编号",
        prop: "number",
        width: "120",
        fixed: true
      },
      {
        label: "基金名称",
        prop: "name",
        width: "180",
        fixed: true
      },
      {
        label: "设立时间",
        width: "180",
        prop: "establishmentTime",

      },
      {
        label: "基金规模",
        prop: "peScale",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(value)+' 元';
          }
        }

      },
      {
        label: "基金实缴金额",
        prop: "totalCapitalPaid",
        width: "160",

        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(Number(value)/10000)+' 万元';
          }
        }
      },  {
        label: "基金已投金额",
        prop: "allFundAmount",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(Number(value)/10000)+' 万元';
          }
        }
      },
       {
        label: "金投股权出资比例",
        prop: "capitalRatio",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return getMoney(value) +' %';
            }
        }
      },
       {
        label: "金投股权实缴额",
        prop: "govIndustryPaid",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(Number(value)/10000)+' 万元';
          }
        }
      },

      {
        label: "基金管理人",
        prop: "managerName",
        width: "100",
        search: false,
      },
      {
        label: "基金协会编码",
        prop: "orgCode",
        width: "180"
        // contactPhone
      },

      {
        label: "基金对接人",
        prop: "managerUserName"
      }
    ]
  }

}
